import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconMagnifyingSg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-magnifying-sg_svg__a)"
      d="M16.958 14.875c.47.5.47 1.281 0 1.781-.5.469-1.28.469-1.78 0l-3.72-3.75c-1.28.844-2.843 1.281-4.53 1.063-2.876-.406-5.188-2.75-5.563-5.594C.833 4.125 4.427.531 8.677 1.062c2.844.375 5.188 2.688 5.594 5.563a6.488 6.488 0 0 1-1.063 4.5l3.75 3.75ZM3.802 7.5c0 2.219 1.781 4 4 4 2.188 0 4-1.781 4-4 0-2.188-1.812-4-4-4-2.219 0-4 1.813-4 4Z"
    />
    <defs>
      <linearGradient
        id="icon-magnifying-sg_svg__a"
        x1={17.333}
        x2={1.333}
        y1={1}
        y2={17}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconMagnifyingSg;
